import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UsersStatusPage } from './users-status';

@NgModule({
  declarations: [
    UsersStatusPage,
  ],
  imports: [
    IonicPageModule.forChild(UsersStatusPage),
  ],
})
export class UsersStatusPageModule {}



// WEBPACK FOOTER //
// ./src/pages/users-status/users-status.module.ts